<template>
  <div v-show="mostra" class="test-box">
    <div class="test-box-content">
      <div class="test-box-wrapper" v-if="mostra">
        <div>id: {{ getUser.id_usuario }}</div>
        <button @click="toggleTrocaCores">
          Troca cores
        </button>
        <button @click="console">
          console.log
        </button>
        <button v-if="modal" v-b-modal="modal">chamaModal</button>
        <button @click="fetchArNcmSelecionados">fetch ncm</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "DebugFront",
  data() {
    return {
      mostra: false,
      modal: "ModalUsuarioPro"
    };
  },
  inject: ["toggleTrocaCores"],
  created() {
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },
  computed: {
    ...mapGetters("login", ["getUser", "getAssinatura", "getPrimeiroLogin"]),
    ...mapGetters("listaNcm", [
      "getContador",
      "getNcms",
      "getMensagemNotificacao",
      "getArNcmSelecionados"
    ])
  },
  methods: {
    ...mapActions("listaNcm", ["fetchArNcmSelecionados"]),
    handleKey(event) {
      if (event.ctrlKey && event.altKey && event.key === "d") {
        this.toggleTestBox();
      }
    },
    console() {
      this.$bus.$emit("console");
    },
    toggleTestBox() {
      this.mostra = !this.mostra;
    }
  }
};
</script>

<style lang="scss" scoped>
.test-box {
  // user-select: none;
  font-size: 10px;
  font-family: "Roboto Condensed";
  position: fixed;
  top: 7px;
  margin: 0 auto;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000000000;
  // width: 100%;
}
.test-box-content {
  background: var(--vermelho4);
  color: #fff;
  padding: 10px;
  border-radius: 10px;
}
.test-box-show-button {
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.test-box-wrapper {
  display: flex;
  flex-direction: column;
}
</style>
